import React from 'react';

import { Routes, Route, NavLink } from 'react-router-dom';

import { ApiObject, Country } from 'app/types';

import Details from 'features/explore/country/tabs/DetailsTab';
import StudentLife from 'features/explore/country/tabs/StudentLifeTab';
import WorkAfterGraduation from 'features/explore/country/tabs/WorkAfterGraduationTab';
import Schools from 'features/explore/country/tabs/SchoolsTab';

import styles from './Tabs.module.scss';

interface CompProps {
  country: ApiObject<Country> | undefined;
}

const TabsComponent = ({ country }: CompProps): React.ReactElement => {
  return (
    <div className={styles.sectionsTabsDT}>
      <div className={styles.blockTabs}>
        <NavLink className={styles.tabs} to={``} replace end>
          Details
        </NavLink>
        <NavLink className={styles.tabs} to={`student_life`} replace>
          Student life
        </NavLink>
        {/* <NavLink className={styles.tabs} to={`immigration`} replace>
          Immigration
        </NavLink> */}
        <NavLink className={styles.tabs} to={`work_after_graduation`} replace>
          Work after graduation
        </NavLink>
        <NavLink className={styles.tabs} to={`schools`} replace>
          Schools
        </NavLink>
      </div>
      <div className={styles.content}>
        <Routes>
          <Route path="/*">
            <Route index element={<Details country={country} />} />
            <Route path="student_life" element={<StudentLife country={country} />} />
            <Route
              path="work_after_graduation"
              element={<WorkAfterGraduation country={country} />}
            />
            <Route path="schools" element={<Schools country={country} />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
};

export default TabsComponent;
